import * as THREE from 'three';
import { SETTINGS } from '../SETTINGS';

export const createCamera = (aspect: number) => {
  const camera = new THREE.PerspectiveCamera(
    SETTINGS.CAMERA.FOV,
    aspect,
    SETTINGS.CAMERA.NEAR,
    SETTINGS.CAMERA.FAR
  );
  camera.position.set(0, 0, 10);
  camera.lookAt(0, 0, 0);
  return camera;
};